import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Tab, Box } from '@mui/material';
export const StyledTab = styled((props) => (
// eslint-disable-next-line react/jsx-props-no-spreading
_jsx(Tab, { component: "div", disableRipple: true, ...props })))(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    marginBottom: 6,
    // text overflow hidden with dots
    display: 'block',
    lineHeight: 1.72,
    width: '100px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    textAlign: 'center',
    //   textTransform: 'lowercase',
    '&.Mui-selected': {
        marginBottom: 0,
        borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
    },
    '&:hover': {
    // color: theme.palette.action.hover,
    // backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
}));
export const TabPanel = ({ children, index, isSelected, firstTab, lastTab, ...other }) => (_jsx(Box, { role: "tabpanel", hidden: !isSelected, id: `simple-tabpanel-${index}`, "aria-labelledby": `simple-tab-${index}`, ...other, children: isSelected && (_jsx(Box, { sx: {
            p: 2.5,
            backgroundColor: 'background.paper',
            boxShadow: '0 0 18px 0 rgba(9, 32, 46, 0.2)',
            borderRadius: 1,
            borderTopLeftRadius: firstTab ? 0 : 1,
            borderTopRightRadius: lastTab ? 0 : 1,
        }, children: children })) }));
TabPanel.defaultProps = {
    children: null,
    firstTab: false,
    lastTab: false,
};
//# sourceMappingURL=CustomTab.js.map